<template>
<div id="representantes" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Nuevo Proceso COVE" class="elevation-1 px-5 py-3" >
                    <v-card-actions>

                        <v-spacer></v-spacer>
                        <v-speed-dial direction="left" open-on-hover>
                            <template v-slot:activator>
                                <v-btn x-small fab dark color="primary" >
                                    <v-icon>reorder</v-icon>
                                </v-btn>
                            </template>

                            <v-btn fab dark x-small color="secondary" @click.native="openModal(1)" title="Nuevo Cove" v-tippy>
                                <v-icon dark>present_to_all</v-icon>
                            </v-btn>

                            <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" @click="downloadLayout('Plantillas/edoc_cove_template.xlsx')" v-tippy>
                                <v-icon dark>receipt</v-icon>
                            </v-btn>

                            <v-btn fab dark x-small color="green darken-2" title="Información de Ayuda" @click="downloadLayout('Plantillas/template_ayuda.xlsx')" v-tippy>
                                <v-icon dark>info</v-icon>
                            </v-btn>
                        </v-speed-dial>

                    </v-card-actions>

                    <v-dialog v-model="modal" max-width="40%" style=" z-index: 400 !important;" >
                        <v-card>
                            <v-card-title>
                                <v-card class="primary white--text titulomodal" >
                                    <v-icon @click.native="modal = false" class="white--text" >cancel</v-icon>&nbsp;
                                    <span class="subheading" >
                                        <strong>Nuevo Cove</strong>
                                    </span>
                                </v-card>                                
                            </v-card-title>
                            <v-card-text>
                                <v-container grid-list-md text-xs-center>
                                    <v-form ref="form" lazy-validation>
                                        <v-card-text>
                                            <v-container grid-list-md text-xs-center @keyup.enter="send()" >
                                                <v-layout row wrap>
                                                    <v-flex s6 m6 l6>
                                                        <v-text-field label="Nombre de Proceso" type="text" v-model="nombre_proceso" maxlength="200" hint="Ingrese el nombre del proceso para poder cargar la plantilla." persistent-hint></v-text-field>
                                                    </v-flex>
                                                </v-layout>

                                                <v-layout row wrap>
                                                    <v-flex s6 m6 l6>
                                                        <span class="v-label theme--light font-weight-bold left" >Cargar Plantilla</span>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap>
                                                    <v-flex s6 m6 l6>
                                                        <!-- firstRow 5, significa que los datos empiezan en el renglón 5-->
                                                        <!-- headerRow 4, significa que los enzabezados están en el renglón 4-->
                                                        <upload-excel-component v-if="nombre_proceso.length>0" :on-success="handleSuccess" :before-upload="beforeUpload" :headerRow=4 :firstRow=5 :headersExcel="headersExcel" />
                                                    </v-flex>
                                                </v-layout>

                                            </v-container>
                                        </v-card-text>
                                    </v-form>
                                </v-container>
                            </v-card-text>                            
                        </v-card>
                    </v-dialog>

                    <v-card-text>
                        <div id="datagrid" >
                            <v-refresh-button :funcion="cargar" />
                            <v-client-table ref="principalTable" :data="registros.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial direction="left" open-on-hover v-if="(props.row.estatus == 'Sin transmitir' || props.row.estatus == 'Transmitido con errores' || props.row.filename != null)" >
                                        <template v-slot:activator>
                                            <v-btn x-small fab dark color="primary" >
                                                <v-icon v-if="fab" >mdi-close</v-icon>
                                                <v-icon v-else>reorder</v-icon>
                                            </v-btn>
                                        </template>                                        
                                        <v-btn x-small fab dark color="purple" v-if="props.row.filename != null" @click.native="downloadFile(props.row.filename)" title="Layout Cargado" v-tippy>
                                            <v-icon>mdi-file-excel</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="red"  v-if="props.row.estatus == 'Sin transmitir'" @click.native="cargarDetalleFactura(props.row.id)" title="Vista Previa PDF" v-tippy>
                                            <v-icon>mdi-file-pdf-box</v-icon>
                                        </v-btn>                                        
                                        <v-btn x-small fab dark color="blue" v-if="(props.row.estatus == 'Sin transmitir' || props.row.estatus == 'Transmitido con errores')" @click.native="transmitir(props.row.id)" title="Transmitir Coves" v-tippy>
                                            <v-icon>send</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" v-if="props.row.estatus == 'Sin transmitir'" @click.native="deleteRegistro(props.row.id)" title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>

                            </v-client-table>
                        </div>
                        <!--div>
                            <v-card class="default " style="font-size:11px;" >
                                <span class="" >
                                    <strong>ESTATUS<br />
                                        Sin transmitir:</strong> COVES sin transmitir.<br />
                                    <strong>Transmitido correctamente:</strong> Todos los COVES transmitidos.<br />
                                    <strong>Transmitido con errores:</strong> Algunos COVES transmitidos con error.<br />
                                </span>
                            </v-card>
                        </div-->
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>

        <v-dialog v-model="modalPdfCove" max-width="70%" style=" z-index: 400 !important;" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon @click.native="modalPdfCove = false" class="white--text" >cancel</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>Vista Previa de COVE Sin Transmitir</strong>
                    </span>
                </v-card>                            
            </v-card-title>     
            <v-card-actions>
                <v-spacer></v-spacer>                                
                <!-- SE CAMBIO A QUE GENERE EL PDF EN BACKEND -->  
                <!--v-btn small outlined color="red" @click="generaPDF('pdfCoves')" title="Exportar a PDF" >
                    <v-icon>mdi-file-pdf-box</v-icon>Exportar a PDF
                </v-btn-->  
                <v-btn small outlined color="red" @click="downloadVistaPrevia(idCoveVistaPrevia)" title="Exportar a PDF" >
                    <v-icon>mdi-file-pdf-box</v-icon>Exportar a PDF
                </v-btn>                  
                <v-btn small outlined @click.native="modalPdfCove = false" >
                    <v-icon>cancel</v-icon> Cerrar
                </v-btn>
            </v-card-actions>            
            <v-card-text>
                
                <v-container v-if="detalle_factura.length > 0" id="pdfCoves" >
                        <span :id="detalle.no_factura" class="manual"  v-for="(detalle, index) in detalle_factura" :key="'factura'+index" >
                            <span v-if="index>0" style="page-break-after: always;" ></span>  
                            <img v-show="showImages" src='/static/logo_negro.png' style='width:20%' id="imageHeader" >                                                                                
                            <h2 class="titulo-principal" ><center>Comprobante de Valor Electrónico</center></h2>
                            
                            <table border=0 width="100%" style="border:1px solid white !important;" >
                                <tr style="border:1px solid white !important;" ><td style="border:1px solid white !important;" >
                                    <p><b style="font-weight: bold;" >Datos del comprobante</b> {{ detalle.datos_factura.comprobantes[0].edocument }}</p>
                                </td></tr>
                            </table>
                            <table>
                                <tr class="title-table" >
                                    <td colspan="2" >Tipo de operación</td>
                                    <td colspan="2" >Relación de facturas</td>
                                    <td colspan="2" >No. de factura</td>
                                </tr>
                                <tr>
                                    <td colspan="2" >{{ detalle.datos_factura.comprobantes[0].tipoOperacion!=undefined ?
                                            (detalle.datos_factura.comprobantes[0].tipoOperacion=='TOCE.IMP'?'Importación':'Exportación') 
                                            : ""
                                          }}</td>
                                    <td colspan="2" >{{ detalle.datos_factura.comprobantes[0].numeroRelacionFacturas=="1" ? "CON RELACION DE FACTURAS" : "SIN RELACION DE FACTURAS" }}</td>
                                    <td colspan="2" >{{ detalle.no_factura }}</td>
                                </tr>
                                <tr class="title-table" >
                                    <td colspan="3" >Tipo de figura</td>
                                    <td colspan="3" >Fecha Exp.</td>
                                </tr>
                                <tr>
                                    <td colspan="3" >{{ detalle.datos_factura.comprobantes[0].tipoFigura!=undefined ?
                                        (detalle.datos_factura.comprobantes[0].tipoFigura.toString() == "4"?'Exportador':'Importador')
                                        : ""
                                         }}</td>
                                    <td colspan="3" >{{ detalle.datos_factura.comprobantes[0].fechaExpedicion }}</td>
                                </tr>
                                <tr class="title-table" >
                                    <td colspan="6" >Observaciones</td>
                                </tr>
                                <tr>
                                    <td colspan="6" >{{ detalle.datos_factura.comprobantes[0].observaciones }}</td>
                                </tr>
                            </table>
                            <br/>                            
                            <table border=0 width="100%" style="border:1px solid white !important;" >
                                <tr style="border:1px solid white !important;" ><td style="border:1px solid white !important;" >
                                    <p style="font-weight: bold;" ><b>RFC con permisos de consulta</b></p>
                                </td></tr>
                            </table>
                            <table>
                                <tr class="title-table" >
                                    <td>RFC de consulta</td>
                                    <td>Nombre o Razón social</td>
                                </tr>
                                <tr v-for="(consulta, index) in detalle.datos_factura.comprobantes[0].rfcConsulta" :v-key="index">
                                    <td>{{ consulta }}</td>
                                    <td>{{ nombresRfcConsulta[consulta] }}</td>
                                </tr>
                            </table>
                            <br/>                            
                            <table border=0 width="100%" style="border:1px solid white !important;" >
                                <tr style="border:1px solid white !important;" ><td style="border:1px solid white !important;" >
                                    <p style="font-weight: bold;" ><b>Número de patente aduanal</b></p>
                                </td></tr>
                            </table>
                            <table>
                                <tr class="title-table" >
                                    <td>Número autorización aduanal</td>
                                </tr>
                                <tr>
                                    <td>{{ detalle.datos_factura.comprobantes[0].patenteAduanal }}</td>
                                </tr>
                            </table>

                            <!-- Datos_factura Generales Factura -->                            
                            <br/>                            
                            <table border=0 width="100%" style="border:1px solid white !important;" >
                                <tr style="border:1px solid white !important;" ><td style="border:1px solid white !important;" >
                                    <p style="font-weight: bold;" ><b>Datos de la factura</b></p>
                                </td></tr>
                            </table>
                            <table>
                                <tr class="title-table" >
                                    <td>Numero Factura</td>
                                    <td>Subdivisión</td>
                                    <td>Certificado de origen</td>
                                    <td>No. de exportador autorizado</td>
                                </tr>
                                <tr>                                        
                                    <td>{{ detalle.no_factura }}</td>                                                                            
                                    <td>{{ detalle.datos_factura.comprobantes[0].factura.subdivision != undefined?
                                            (detalle.datos_factura.comprobantes[0].factura.subdivision.toString()=='0'?'Sin Subdivisión':
                                            detalle.datos_factura.comprobantes[0].factura.subdivision)
                                            : ''
                                            }}</td>
                                    <td>{{ detalle.datos_factura.comprobantes[0].factura.certificadoOrigen != undefined?
                                            (detalle.datos_factura.comprobantes[0].factura.certificadoOrigen.toString()=='0'?'No funge como certificado de origen':
                                            'Si funge como certificado de origen')
                                            : ''
                                            }}</td>                                                                        
                                    <td>{{ detalle.datos_factura.comprobantes[0].factura.numeroExportadorAutorizado }}</td>
                                </tr>
                            </table>

                            <!-- Datos Generales Emisor -->
                            <br/>
                            <table border=0 width="100%" style="border:1px solid white !important;" >
                                <tr style="border:1px solid white !important;" ><td style="border:1px solid white !important;" >
                                    <p style="font-weight: bold;" ><b>Datos generales del emisor</b></p>
                                </td></tr>
                            </table>
                            <table>
                                <tr class="title-table" >
                                    <td>Tipo de identificador</td>
                                    <td colspan="2" >Tax ID/Sin Tax ID/RFC/CURP</td>
                                </tr>
                                
                                <tr>
                                    <td>
                                        {{ getTipoIdentificador(detalle.datos_factura.comprobantes[0].emisor.tipoIdentificador) }}
                                    </td>                                    
                                    <td colspan="2" >{{ detalle.datos_factura.comprobantes[0].emisor.identificacion }}</td>
                                </tr>
                                <tr class="title-table" >
                                    <td>Nombre(s) o Razón Social</td>
                                    <td>Apellido paterno</td>
                                    <td>Apellido materno</td>
                                </tr>
                                <tr>
                                    <td>{{ detalle.datos_factura.comprobantes[0].emisor.nombre }}</td>
                                    <td>{{ detalle.datos_factura.comprobantes[0].emisor.apellidoPaterno }}</td>
                                    <td>{{ detalle.datos_factura.comprobantes[0].emisor.apellidoMaterno }}</td>
                                </tr>
                                                                   
                            </table>

                            <br/>                            
                            <table border=0 width="100%" style="border:1px solid white !important;" >
                                <tr style="border:1px solid white !important;" ><td style="border:1px solid white !important;" >
                                    <p style="font-weight: bold;" ><b>Domicilio del emisor</b></p>
                                </td></tr>
                            </table>
                            <table>
                                <tr class="title-table" >
                                    <td colspan="3" >Calle</td>
                                    <td>No. exterior</td>
                                    <td>No. interior</td>
                                    <td>Código postal</td>
                                </tr>
                                
                                <tr>
                                    <td colspan="3" >{{ detalle.datos_factura.comprobantes[0].emisor.domicilio.calle }}</td>
                                    <td>{{ detalle.datos_factura.comprobantes[0].emisor.domicilio.numeroExterior }}</td>
                                    <td>{{ detalle.datos_factura.comprobantes[0].emisor.domicilio.numeroInterior }}</td>
                                    <td>{{ detalle.datos_factura.comprobantes[0].emisor.domicilio.codigoPostal }}</td>
                                </tr>
                                <tr class="title-table" >
                                    <td colspan="3" >Colonia</td>
                                    <td colspan="3" >Localidad</td>
                                </tr>
                                <tr>
                                    <td colspan="3" >{{ detalle.datos_factura.comprobantes[0].emisor.domicilio.colonia }}</td>
                                    <td colspan="3" >{{ detalle.datos_factura.comprobantes[0].emisor.domicilio.localidad }}</td>
                                </tr>
                                <tr class="title-table" >
                                    <td colspan="3" >Entidad federativa</td>
                                    <td colspan="3" >Municipio</td>
                                </tr>
                                <tr>
                                    <td colspan="3" >{{ detalle.datos_factura.comprobantes[0].emisor.domicilio.entidadFederativa }}</td>
                                    <td colspan="3" >{{ detalle.datos_factura.comprobantes[0].emisor.domicilio.municipio }}</td>
                                </tr>
                                <tr class="title-table" >
                                    <td colspan="6" >País</td>
                                </tr>
                                <tr>
                                    <td colspan="6" >{{ getNombrePais(detalle.datos_factura.comprobantes[0].emisor.domicilio.pais) }}</td>
                                </tr>                               
                            </table>

                            <br/>                                                        
                            <table border=0 width="100%" style="border:1px solid white !important;" >
                                <tr style="border:1px solid white !important;" ><td style="border:1px solid white !important;" >
                                    <p style="font-weight: bold;" ><b>Datos generales del destinatario</b></p>
                                </td></tr>
                            </table>
                            <table>
                                <tr class="title-table" >    
                                    <td>Tipo de identificador</td>
                                    <td colspan="2" >Tax ID/Sin Tax ID/RFC/CURP</td>
                                </tr>
                                
                                <tr>
                                    <td>
                                        {{ getTipoIdentificador(detalle.datos_factura.comprobantes[0].destinatario.tipoIdentificador) }}
                                    </td>                                    
                                    <td colspan="2" >{{ detalle.datos_factura.comprobantes[0].destinatario.identificacion }}</td>
                                </tr>
                                <tr class="title-table" >
                                    <td>Nombre(s) o Razón Social</td>
                                    <td>Apellido paterno</td>
                                    <td>Apellido materno</td>
                                </tr>
                                <tr>
                                    <td>{{ detalle.datos_factura.comprobantes[0].destinatario.nombre }}</td>
                                    <td>{{ detalle.datos_factura.comprobantes[0].destinatario.apellidoPaterno }}</td>
                                    <td>{{ detalle.datos_factura.comprobantes[0].destinatario.apellidoMaterno }}</td>
                                </tr>
                                                                   
                            </table>

                            <br/>                            
                            <table border=0 width="100%" style="border:1px solid white !important;" >
                                <tr style="border:1px solid white !important;" ><td style="border:1px solid white !important;" >
                                    <p style="font-weight: bold;" ><b>Domicilio del destinatario</b></p>
                                </td></tr>
                            </table>
                            <table>
                                <tr class="title-table" >
                                    <td colspan="3" >Calle</td>
                                    <td>No. exterior</td>
                                    <td>No. interior</td>
                                    <td>Código postal</td>
                                </tr>
                                
                                <tr>
                                    <td colspan="3" >{{ detalle.datos_factura.comprobantes[0].destinatario.domicilio.calle }}</td>
                                    <td>{{ detalle.datos_factura.comprobantes[0].destinatario.domicilio.numeroExterior }}</td>
                                    <td>{{ detalle.datos_factura.comprobantes[0].destinatario.domicilio.numeroInterior }}</td>
                                    <td>{{ detalle.datos_factura.comprobantes[0].destinatario.domicilio.codigoPostal }}</td>
                                </tr>
                                <tr class="title-table" >
                                    <td colspan="3" >Colonia</td>
                                    <td colspan="3" >Localidad</td>
                                </tr>
                                <tr>
                                    <td colspan="3" >{{ detalle.datos_factura.comprobantes[0].destinatario.domicilio.colonia }}</td>
                                    <td colspan="3" >{{ detalle.datos_factura.comprobantes[0].destinatario.domicilio.localidad }}</td>
                                </tr>
                                <tr class="title-table" >
                                    <td colspan="3" >Entidad federativa</td>
                                    <td colspan="3" >Municipio</td>
                                </tr>
                                <tr>
                                    <td colspan="3" >{{ detalle.datos_factura.comprobantes[0].destinatario.domicilio.entidadFederativa }}</td>
                                    <td colspan="3" >{{ detalle.datos_factura.comprobantes[0].destinatario.domicilio.municipio }}</td>
                                </tr>
                                <tr class="title-table" >
                                    <td colspan="6" >País</td>
                                </tr>
                                <tr>
                                    <td colspan="6" >{{ getNombrePais(detalle.datos_factura.comprobantes[0].destinatario.domicilio.pais) }}</td>
                                </tr>
                               
                            </table>

                            <!-- Datos Mercancias -->
                            <span v-for="(datos_mercancia, indexMerca) in detalle.datos_factura.comprobantes[0].mercancias" :key="'mercancia'+indexMerca" >
                                <br>                                
                                <table border=0 width="100%" style="border:1px solid white !important;" >
                                    <tr style="border:1px solid white !important;" ><td style="border:1px solid white !important;" >
                                        <p style="font-weight: bold;" ><b>Datos de la mercancía</b></p>
                                    </td></tr>
                                </table>
                                <table width="100%" >
                                    <tr class="title-table" >
                                        <td colspan="2" >Descripción genérica de la mercancía</td>
                                        <td>Clave UMC</td>
                                        <td>Cantidad UMC</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" >{{ datos_mercancia.descripcionGenerica }}</td>
                                        <td>{{ getDescripcion(datos_mercancia.claveUnidadMedida, unidadesMedida) }}</td>
                                        <td>{{ formatNumber(datos_mercancia.cantidad,3) }}</td>
                                    </tr>
                                    <tr class="title-table" >
                                        <td>Tipo moneda</td>
                                        <td>Valor unitario</td>
                                        <td>Valor total</td>
                                        <td>Valor total en dólares</td>
                                    </tr>
                                    <tr>
                                        <td>{{ getDescripcion(datos_mercancia.tipoMoneda, tiposMoneda) }}</td>
                                        <td>$ {{ formatNumber(datos_mercancia.valorUnitario,6) }}</td>
                                        <td>$ {{ formatNumber(datos_mercancia.valorTotal,6) }}</td>
                                        <td>$ {{ formatNumber(datos_mercancia.valorDolares,4) }}</td>
                                    </tr>
                                </table>
                                
                                <span v-if="datos_mercancia.descripcionesEspecificas.length>0" >
                                    <br/>
                                    <table border=0 width="100%" style="border:1px solid white !important;" >
                                        <tr style="border:1px solid white !important;" ><td style="border:1px solid white !important;" >
                                            <p style="font-weight: bold;" ><b>Descripción de la mercancía</b></p>
                                        </td></tr>
                                    </table>
                                    <table width="100%" >
                                        <tr class="title-table" >
                                            <td>Marca</td>
                                            <td>Modelo</td>
                                            <td>Submodelo</td>
                                            <td>No. serie</td>
                                        </tr>                                                                            
                                        <tr v-for="(descripcion, indexDes) in datos_mercancia.descripcionesEspecificas" :key="'descEsp'+indexDes" >
                                            <td>{{ descripcion.marca }}</td>
                                            <td>{{ descripcion.modelo }}</td>
                                            <td>{{ descripcion.subModelo }}</td>
                                            <td>{{ descripcion.numeroSerie }}</td>                                            
                                        </tr>
                                        </table>                                                 
                                </span>                                                             
                            </span> <!-- For de mercancias-->                            

                        </span>                       
                </v-container>
            </v-card-text>                   
        </v-card>
    </v-dialog>
        
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import html2pdf from "html2pdf.js";
import RefreshButton from "@/components/RefreshButton.vue";
export default {
    components: {"v-refresh-button": RefreshButton,},

    data: () => ({
        nombresRfcConsulta: {},
        fab: false,
        file: "",
        ext_file: "",
        unidadesMedida:[],
        tiposMoneda:[],
        paises:[],
        modalPdfCove: false,
        idCoveVistaPrevia: "",
        detalle_factura: [],
        showImages:true,
        name: "datagrid",
        importData: [],
        nombre_proceso: "",
        modal: false,
        cliente: '',
        usuario: '',
        rfc: '',
        columns: [
            "id",
            "nombre_proceso",
            "fecha",
            "usuario_email",
            "fecha_envio",
            "enviado_por",
            "estatus",
            "actions"
        ],
        options: {
            filterable: [
                "id",
                "nombre_proceso",
                "fecha",
                "fecha_envio",
                "enviado_por",
                "usuario_email",
                "estatus",
            ],
            sortable: [
                "id",
                "nombre_proceso",
                "fecha",
                "fecha_envio",
                "enviado_por",
                "usuario_email",
                "estatus",
            ],

            headings: {
                id:"No. Proceso",
                nombre_proceso: "Nombre de Proceso",
                fecha: "Fecha",
                fecha_envio: "Fecha de Envío",
                usuario_email: "Usuario",
                estatus: "Estatus",
                actions: "Operaciones",
            },
            uniqueKey: "id",
        },

        rules: {
            required: v => !!v || "Este campo es requerido",
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "Correo electrónico no valido";
            },
        },

        URL: "",
        show_loading: true,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Vucem-Transmisión",
                disabled: true,
                to: ""
            },
            {
                text: "Nuevo Proceso COVE",
                disabled: true,
                to: ""
            }
        ],
        emisores: [],
        sellos: [],
        ws_password: '',

        registros: {
            selected: [],
            items: [0],
        },
        facturas: {
            items: [],
            camposexcel: {
                "no_factura": "no_factura",
                "no_operacion": "no_operacion",
                "nombre_cove": "nombre_cove",
                "partidas": "partidas",
                "estatus": "estatus",
                "error": "error",
                "errores": "errores",
            },
        },
        columnsFacturas: [
            "no_factura",
            "no_operacion",
            "nombre_cove",
            "partidas",
            "estatus",
            "error",
            "errores",
            "xml",
            "pdf",
            "acuse",
        ],
        optionsFacturas: {
            filterable: [
                "no_factura",
                "no_operacion",
                "nombre_cove",
                "partidas",
                "estatus",
                "error",
            ],
            sortable: [
                "no_factura",
                "no_operacion",
                "nombre_cove",
                "partidas",
                "estatus",
                "error",
            ],
            headings: {
                no_factura: "Factura",
                o_operacion: "No. Operación",
                nombre_cove: "COVE",
                partidas: "Partidas",
                estatus: "Estatus",
                error: "Error Transmisión",
                errores: "Error Recuperación",
                xml: "XML",
                pdf: "PDF",
                acuse: "Acuse",
            }
        },

        registro_seleccionado: '',

        headersExcel: [
            "edocument",
            "tipoOperacion",
            "emisor",
            "destinatario",
            "patenteAduanal",
            "fechaExpedicion",
            "observaciones",
            "rfcConsulta",
            "tipoFigura",
            "correoElectronico",
            "numeroFacturaOriginal",
            "relaciondeFacturas",
            "certificadoOrigen",
            "numeroExportadorAutorizado",
            "subdivision",
            "terminoFacturacion",
            "numeroPartida",
            "descripcionGenerica",
            "claveUnidadMedida",
            "tipoMoneda",
            "cantidad",
            "valorUnitario",
            "valorTotal",
            "valorDolares",
            "marca",
            "modelo",
            "subModelo",
            "numeroSerie"
        ],
        equivalencias: {
            "edocument": "E-Document",
            "tipoOperacion": "Tipo de Operación",
            "emisor": "Identificación Fiscal Emisor",
            "destinatario": "Identificación Fiscal Destinatario",
            "patenteAduanal": "Patente del Agente Aduanal",
            "tipoFigura": "Tipo de Figura",
            "observaciones": "Observaciones",
            "rfcConsulta": "RFC Consulta",
            "correoElectronico": "Correo Electrónico",
            "numeroFacturaOriginal": "Número de Factura",
            "relaciondeFacturas": "Relación de Facturas",
            "certificadoOrigen": "Certificado Origen",
            "numeroExportadorAutorizado": "Número de Exportador Autorizado",
            "subdivision": "Subdivisión",
            "terminoFacturacion": "Término Facturación",
            "descripcionGenerica": "Descripción Genérica",
            "claveUnidadMedida": "Clave de la unidad de medida",
            "tipoMoneda": "Tipo de Moneda",
            "marca": "Marca",
            "modelo": "Modelo",
            "subModelo": "Sub-Modelo",
            "numeroSerie": "Numero de Serie"
        },

        maxLen: {
            "edocument": 13,
            "tipoOperacion": 1,
            "emisor": 50,
            "destinatario": 50,
            "patenteAduanal": 4,
            "observaciones": 1000,
            "rfcConsulta": 13,
            "tipoFigura": 1,
            "correoElectronico": 70,
            "numeroFacturaOriginal": 36,
            "relaciondeFacturas": 4,
            "certificadoOrigen": 1,
            "numeroExportadorAutorizado": 50,
            "subdivision": 1,
            "terminoFacturacion": 3,
            "descripcionGenerica": 256,
            "claveUnidadMedida": 30,
            "tipoMoneda": 3,            
        },

        camposObligatorios: {
            "tipoOperacion": "Tipo de Operación",
            "emisor": "Identificación Fiscal Emisor",
            "destinatario": "Identificación Fiscal Destinatario",
            "patenteAduanal": "Patente del Agente Aduanal",
            "fechaExpedicion": "Fecha de Expedición",
            "tipoFigura": "Tipo de Figura",
            "correoElectronico": "Correo Electrónico",
            "numeroFacturaOriginal": "Número de Factura",
            "relaciondeFacturas": "Relación de Facturas",
            "certificadoOrigen": "Certificado Origen",
            "subdivision": "Subdivisión",
            "numeroPartida": "Número de Partida",
            "descripcionGenerica": "Descripción Genérica",
            "claveUnidadMedida": "Clave de la unidad de medida",
            "tipoMoneda": "Tipo de Moneda",
            "cantidad": "Cantidad",
            "valorUnitario": "Valor Unitario",
            "valorTotal": "Valor Total",
            "valorDolares": "Valor en Dólares",
        },
    }),
     
    computed: {
        getNameExcel() {
            return "CovesTransmitidos" + this.rfc + ".xlsx";
        },
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.facturas.items;
            }

        },
    },

    methods: {
        openModal: function (type) {
            this.modal = true;
        },
        getTipoIdentificador(idTipo){
            var tipo = idTipo.toString();
            if (tipo == "1")
                return "RFC";
            else if (tipo == "2")
                return "CURP";
            else if (tipo == "3")
                return "Sin Tax ID";
            else 
                return "Tax ID";
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateExcel(excelDate) {
            try {
                if (!excelDate) return false;
                var fecha = '';
                if (excelDate.toString().indexOf('/') != -1 || excelDate.toString().indexOf('-') != -1)
                    fecha = moment(String(excelDate)).format("YYYY-MM-DD");
                else
                    fecha = moment((excelDate - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");
                if (fecha == 'Invalid date') return false;
                return fecha;
            } catch (error) {
                return false;
            }
        },

        cargar: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                rfc: this.rfc
            };
            axios
                .post(this.URL + "get_coves/", datos)                
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.registros.items = res.data;
                        this.registros.items.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha) - new Date(a.fecha) ;
                        });
                        for (var k in this.registros.items) {
                            this.registros.items[k].fecha = this.parseDate(this.registros.items[k].fecha);
                            this.registros.items[k].fecha_envio = this.parseDate(this.registros.items[k].fecha_envio);
                            this.registros.items[k].estatus = this.getEstatus(this.registros.items[k].estatus);
                        }
                    }
                })
                .catch(err => {
                    
                    console.log(err);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        showDetail: function (row) {
            if (this.registro_seleccionado != row.id) {
                this.registro_seleccionado = row.id;
                this.cargarFacturas();
                var detallesAbiertos = this.$refs.principalTable.openChildRows;
                for (var k in detallesAbiertos) { //Cerramos detalles abiertos
                    if (detallesAbiertos[k] != row.id)
                        this.$refs.principalTable.toggleChildRow(detallesAbiertos[k]);
                }
            } else { //Significa que dio clic en '-' solo cerramos el detalle y no hacemos nada
                this.registro_seleccionado = '';
            }
            this.$refs.principalTable.toggleChildRow(row.id); //Mostramos detalle seleccionado

        },

        cargarFacturas: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: this.registro_seleccionado
            };
            axios
                .post(this.URL + "get_detalles_coves/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.facturas.items = res.data;
                        //LOS CAMPOS xml, pdf y acuse, tienen valores (0-Pendiente, 1-En cola, 2-Recuperado, 3-Error, 4-No recuperable)
                        for (var k in this.facturas.items) {
                            this.facturas.items[k].estatus = this.getEstatusDetalle(this.facturas.items[k].estatus);
                            if (this.facturas.items[k].errores != null) {
                                var errores_string = '';
                                var thisObject = this;
                                var err_array = this.facturas.items[k].errores.map(function (err) {
                                    return thisObject.parseDate(err.fecha) + ": " + err.error;
                                });
                                err_array.forEach(element => {
                                    errores_string += element + ", ";
                                });
                                this.facturas.items[k].errores = errores_string;
                            }
                        }

                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los coves del registro seleccionado.",
                        footer: ""
                    });
                    console.log(err);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        getEstatus: function (estatus) {
            var arr_estatus = ["Sin transmitir", "Transmitido correctamente", "Transmitido con errores", "Transmitiendo"];
            if (estatus in arr_estatus)
                return arr_estatus[estatus];
            else
                return "N/A";
        },

        getEstatusDetalle: function (estatus) {
            var arr_estatus = ["Pendiente", "Transmitido", "Aceptado", "Rechazado"];
            if (estatus in arr_estatus)
                return arr_estatus[estatus];
            else
                return "N/A";
        },

        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            var nombre = file.name.split(".")
            this.ext_file = nombre[nombre.length - 1];            

            if (isLt2M) {                
                const fr = new FileReader()
                fr.readAsDataURL(file)

                fr.addEventListener('load', () => {
                    this.file = fr.result; // this is an image file that can be sent to server...          
                    var n = this.file.search("base64,");
                    //Para dejar solo el archivo en base 64 y quitar laparte de "text/plain; base64,"
                    if (n >= 0) {
                        this.file = this.file.substring(n + 7);
                    }                                       
                });
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }

            for (var key in this.camposObligatorios) {
                if (keys.indexOf(key) == -1)
                    errores += '<br/>' + "- El campo '" + this.camposObligatorios[key] + "' es obligatorio.";
            }

            return errores == '' ? true : errores;
        },
        verificaMaxlen: function (results) {
            var errores = '';

            for (var key in this.maxLen) {
                if (key == "rfcConsulta" && results[key] != null) {
                    var rfcs = results["rfcConsulta"].split(",");
                    for (var r in rfcs) {
                        if (rfcs[r].toString().trim().length > this.maxLen[key]) {
                            errores += '<br/>' + "- El campo '" + this.equivalencias[key] + ":" + rfcs[r].toString().trim() +
                                "' no permite más de " + this.maxLen[key] + (this.maxLen[key] > 1 ? " caracteres/digitos." : " caracter/digito.");
                        }
                    }
                } else {
                    if (results[key] != null && results[key].toString().trim().length > this.maxLen[key]) {
                        errores += '<br/>' + "- El campo '" + this.equivalencias[key] + ":" + results[key].toString().trim() +
                            "' no permite más de " + this.maxLen[key] + (this.maxLen[key] > 1 ? " caracteres/digitos." : " caracter/digito.");
                    }
                }

            }

            return errores == '' ? true : errores;
        },

        validaCorreo: function (mail) {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(mail);
        },

        cargarEmisores: function () {
            var datos = {
                cliente: this.cliente
            };
            axios
                .post(this.$hostname + "catalogos/emisores_destinatarios/get_emisores/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.emisores = res.data;
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los emisores.",
                        footer: ""
                    });
                });
        },

        cargarCertificados: function () {
            var rfc = this.rfc;
            var datos = {
                cliente: this.cliente
            };
            axios
                .post(this.$hostname + "catalogos/certificados/list_certificados/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.sellos = res.data;
                        if (this.sellos.length > 0) {
                            var search = this.sellos.filter(function (e) {
                                return e.estatus == 1 && e.activo == true; //1-Sello correcto
                            });
                            if (search.length > 0) {
                                let sello = search[0];
                                this.ws_password = sello.clave_ws;
                            } else {
                                var search2 = this.sellos.filter(function (e) {
                                    return e.estatus == 0 && e.activo == true; //0-Sello sin probar
                                });
                                if (search2.length > 0) {
                                    let sello = search2[0];
                                    this.ws_password = sello.clave_ws;
                                } else {
                                    this.$swal({
                                        type: "warning",
                                        title: "Advertencia",
                                        text: "El cliente: " + rfc + " no tiene sellos digitales validados. Favor de verificar.",
                                        footer: ""
                                    });

                                }
                            }
                        } else {
                            this.$swal({
                                type: "warning",
                                title: "Advertencia",
                                text: "No se han configurado sellos digitales para el cliente: " + rfc,
                                footer: ""
                            });
                        }
                    }
                })
                .catch(err => {
                   
                });
        },

        verificaEmisor: function (emisor, opcion) {
            if (emisor == undefined)
                return false;

            var search = this.emisores.filter(function (e) {
                return e.rfc.toString().trim().toUpperCase() == emisor.toString().trim().toUpperCase();
            });
            if (opcion == 'domicilio')
                return search.length > 0 ? search[0] : '';
            else
                return search.length > 0;
        },

        cargarUnidadesMedida: function () {
            axios
                .post(this.$hostname + "catalogos/unidades_medida/lista/",{cliente:this.$local_storage.get("id_cliente")})
                .then(res => {                    
                    this.unidadesMedida = res.data;
                })
                .catch(err => {                   
                    console.log(err);
                });
        },
        cargarTiposMoneda: function () {
            axios
                .post(this.$hostname + "apendices/lista/",{tabla:10})
                .then(res => {                    
                    this.tiposMoneda = res.data;                    
                })
                .catch(err => {                   
                    console.log(err);
                });
        },
        cargarPaises: function () {
            axios
                .post(this.$hostname + "apendices/lista/",{tabla:17})
                .then(res => {                             
                    this.paises = res.data;                                        
                })
                .catch(err => {                   
                    console.log(err);
                });
        },

        getDescripcion: function(clave_in, arreglo){
            if (clave_in != null && clave_in.toString().trim()!="" && arreglo!=null && Array.isArray(arreglo)){
                var filter = arreglo.filter(function(e){
                    return e.clave.toString().trim().toUpperCase() == clave_in.toString().trim().toUpperCase();
                });
                if (filter.length>0){
                    return filter[0].descripcion;
                } 
            }
            return clave_in;            
        },
        getNombrePais: function(clave_in){
            if (clave_in != null && clave_in.toString().trim()!="" && this.paises!=null && Array.isArray(this.paises)){
                var filter = this.paises.filter(function(e){
                    return e.clave_m3.toString().trim().toUpperCase() == clave_in.toString().trim().toUpperCase();
                });
                if (filter.length>0){
                    return filter[0].nombre;
                } 
            }
            return clave_in;            
        },

        formatNumber: function(numero, decimales){
            if (numero == undefined || numero == null || numero == "")
                numero = 0;
            numero = Number(numero);
            if (isNaN(numero)){
                return "";
            } else 
                return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        },

        cargarAduanas: function () {
            axios
                .get(this.$hostname + "catalogos/aduanas/")
                .then(res => {
                    if (typeof res.data !== "undefined")
                        this.aduanas = res.data;
                    else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de aduanas",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                   
                    console.log(err);
                });
        },

        obtenerAduana(id_aduana) {
            let aduanas = this.aduanas.filter(function (e) {
                return e.id_aduana == id_aduana;
            });
            return aduanas.length > 0 ? (aduanas[0].clave + " - " + aduanas[0].nombre) : "N/A";
        },
        verificaAduana: function (aduana, opcion) {
            if (aduana == undefined)
                return false;

            var search = this.aduanas.filter(function (e) {
                return parseInt(e.clave.toString().trim()) == parseInt(aduana.toString().trim());
            });
            if (opcion == 'id')
                return search.length > 0 ? search[0].clave : '';
            else
                return search.length > 0;
        },

        //Validamos números Float con punto decimal y que cumpla con el número de decimales
        verificaDecimales: function (valor, numeroDecimales) {
            var cantidad_split = valor.toString().split(".");
            if (cantidad_split.length == 1) {
                if (Number.isNaN(parseInt(cantidad_split[0]))) {
                    return false;
                } else
                    return parseInt(cantidad_split[0]).toString() + "." + "0".repeat(numeroDecimales);
            } else if (cantidad_split.length == 2) {
                if (Number.isNaN(parseInt(cantidad_split[0])) || Number.isNaN(parseInt(cantidad_split[1]))) {
                    return false;
                } else if (cantidad_split[1].toString().length > numeroDecimales) {
                    var newNum = Math.round(valor * Math.pow(10, numeroDecimales)) / Math.pow(10, numeroDecimales);
                    return this.verificaDecimales(newNum, numeroDecimales);
                } else {
                    var repetir = numeroDecimales - cantidad_split[1].toString().length;
                    if (repetir == 0)
                        return parseInt(cantidad_split[0]).toString() + "." + cantidad_split[1].toString();
                    else
                        return parseInt(cantidad_split[0]).toString() + "." + cantidad_split[1].toString() + "0".repeat(repetir);

                }

            } else
                return false;
        },

        validaCargaLayout: async function (results) {
            var thisObject = this;
            var errores = 0;
            var erroresText = '';
            var errorTmp = '';
            var rfc = thisObject.rfc;

            try {
                if (results.length == 0) {
                    errores++;
                    erroresText += "No hay datos en el layout. Verifique que exista información del 5to renglón en adelante.";
                } else {
                    for (var k in results) {

                        var obligatorios = thisObject.verificaObligatorios(results[k]);
                        if (obligatorios !== true) {
                            errores++;
                            if (erroresText.indexOf(obligatorios) == -1)
                                erroresText += obligatorios;
                        } else {
                            var maxlen = thisObject.verificaMaxlen(results[k]);
                            if (maxlen !== true) {
                                errores++;
                                if (erroresText.indexOf(maxlen) == -1)
                                    erroresText += maxlen;
                            }

                            if (!Number.isInteger(results[k]["tipoOperacion"]) || (results[k]["tipoOperacion"] != 1 && results[k]["tipoOperacion"] != 2)) {
                                errores++;
                                errorTmp = "<br>- Tipo de Operación no válido: \"" + results[k]["tipoOperacion"] + "\", debe ser un número entero (1 o 2).";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            if (rfc != results[k]["emisor"].toString().toUpperCase() && rfc != results[k]["destinatario"].toString().toUpperCase()) {
                                errores++;
                                errorTmp = "<br>- El RFC de la actual sesion: \"" + rfc + "\", debe fungir como emisor o destinatario forzosamente.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if (!thisObject.verificaEmisor(results[k]["emisor"])) {
                                errores++;
                                errorTmp = "<br>- El emisor: \"" + results[k]["emisor"] + "\", no existe en el catálogo de emisores/destinatarios.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            if (!thisObject.verificaEmisor(results[k]["destinatario"])) {
                                errores++;
                                errorTmp = "<br>- El destinatario: \"" + results[k]["destinatario"] + "\", no existe en el catálogo de emisores/destinatarios.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            var fechaOrig = results[k]["fechaExpedicion"];
                            results[k]["fechaExpedicion"] = thisObject.parseDateExcel(fechaOrig);
                            if (results[k]["fechaExpedicion"] == false) {
                                errores++;
                                errorTmp = '<br/>' + "- La fecha '" + fechaOrig + "' no es una fecha válida.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if (results[k]["rfcConsulta"] != null) {
                                if (results[k]["rfcConsulta"].toString().trim() != '')
                                    results[k]["rfcConsulta"] = results[k]["rfcConsulta"].toString().trim().split(",");
                                else
                                    results[k]["rfcConsulta"] = null;
                            }

                            if (!Number.isInteger(results[k]["tipoFigura"]) || (results[k]["tipoFigura"] != 4 && results[k]["tipoFigura"] != 5)) {
                                errores++;
                                errorTmp = "<br>- Tipo de Figura no válido: " + results[k]["tipoFigura"] + ", debe ser un número entero (4 o 5).";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if (!thisObject.validaCorreo(results[k]["correoElectronico"])) {
                                errores++;
                                errorTmp = "<br>- El correo: " + results[k]["correoElectronico"] + ", no es válido.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if (!Number.isInteger(results[k]["relaciondeFacturas"]) || (results[k]["relaciondeFacturas"] != 0 && results[k]["relaciondeFacturas"] != 1)) {
                                errores++;
                                errorTmp = "<br>- Relación de Facturas no válido: " + results[k]["relaciondeFacturas"] + ", debe ser un número entero (0 o 1).";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if (!Number.isInteger(results[k]["certificadoOrigen"]) || (results[k]["certificadoOrigen"] != 0 && results[k]["certificadoOrigen"] != 1)) {
                                errores++;
                                errorTmp = "<br>- Certificado Origen no válido: " + results[k]["certificadoOrigen"] + ", debe ser un número entero (0 o 1).";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if (!Number.isInteger(results[k]["subdivision"]) || (results[k]["subdivision"] != 0 && results[k]["subdivision"] != 1)) {
                                errores++;
                                errorTmp = "<br>- Subdivisión no válida: " + results[k]["subdivision"] + ", debe ser un número entero (0 o 1).";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if (!Number.isInteger(results[k]["numeroPartida"])) {
                                errores++;
                                errorTmp = "<br>- Número de Partida no válido: " + results[k]["numeroPartida"] + ", debe ser un número entero.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if (thisObject.verificaDecimales(results[k]["cantidad"], 3) === false) {
                                errores++;
                                errorTmp = "<br>- Cantidad no válido: " + results[k]["cantidad"] + ", debe ser un número válido con 3 decimales.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else
                                results[k]["cantidad"] = thisObject.verificaDecimales(results[k]["cantidad"], 3);

                            if (thisObject.verificaDecimales(results[k]["valorUnitario"], 6) === false) {
                                errores++;
                                errorTmp = "<br>- Valor Unitario no válido: " + results[k]["valorUnitario"] + ", debe ser un número válido con 6 decimales.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else
                                results[k]["valorUnitario"] = thisObject.verificaDecimales(results[k]["valorUnitario"], 6);

                            if (thisObject.verificaDecimales(results[k]["valorTotal"], 6) === false) {
                                errores++;
                                errorTmp = "<br>- Valor Total no válido: " + results[k]["valorTotal"] + ", debe ser un número válido con 6 decimales.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else
                                results[k]["valorTotal"] = thisObject.verificaDecimales(results[k]["valorTotal"], 6);
                            //console.log(results[k]["valorTotal"]);

                            if (thisObject.verificaDecimales(results[k]["valorDolares"], 4) === false) {
                                errores++;
                                errorTmp = "<br>- Valor Dolares no válido: " + results[k]["valorDolares"] + ", debe ser un número válido con 4 decimales.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else
                                results[k]["valorDolares"] = thisObject.verificaDecimales(results[k]["valorDolares"], 4);

                        }
                        //console.log("Key is " + k + ", value is" + results[k]);
                    }

                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                //console.log(error);
                return ({
                    "errores": 1,
                    "erroresText": error.message
                });
            }

        },
        handleSuccess: async function ({
            results,
            header
        }) {
            var errores = 0;
            var erroresText = '';                      
            var facturas = [];           

            try {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                //console.log(header);
                //console.log(results);
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    const valoresIncorrectos = [null, undefined, '']
                    var partidasConError = []
                    var partidasTotal = [... new Set(results.map(x => x.numeroPartida + "__" + x.numeroFacturaOriginal))]
                    for (let i = 0; i < partidasTotal.length; i++) {
                        const [element, facturaStr] = partidasTotal[i].split("__");
                        var contadorNulos = 0

                        let partidasBuscadas = results.filter(x => x.numeroPartida == element && x.numeroFacturaOriginal == facturaStr)

                        if (partidasBuscadas.length > 1) {
                            partidasBuscadas.forEach( row => {
                                if(valoresIncorrectos.includes(row.marca) && valoresIncorrectos.includes(row.modelo) && valoresIncorrectos.includes(row.subModelo) && valoresIncorrectos.includes(row.numeroSerie)) {
                                    contadorNulos += 1
                                }
                            });

                            if(contadorNulos > 1) partidasConError.push(element.toString())
                        }
                        
                    }

                    if(partidasConError.length > 0) {
                        this.$swal({
                            type: "warning",
                            title: "¡Operación no Permitida!",
                            text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                            footer: "Partidas duplicadas sin descripciones especificas: No. Partida " + partidasConError.toString(),
                        });
                        this.$root.$dialogLoader.hide();
                        return
                    }

                    var resultadoFinal = [];
                    for (var k in results) {
                        var key_factura = results[k]["numeroFacturaOriginal"].toString().trim();
                        var numPartida = results[k]["numeroPartida"].toString().trim();                        

                        if (facturas[key_factura] == null)
                            facturas[key_factura] = {};

                        if (facturas[key_factura]["mercancias"] == null)
                            facturas[key_factura]["mercancias"] = [];
                        if (facturas[key_factura]["mercancias"][numPartida] == null)
                            facturas[key_factura]["mercancias"][numPartida] = {};

                        if (results[k]["edocument"] != null)
                            facturas[key_factura]['edocument'] = results[k]["edocument"].toString();
                        facturas[key_factura]['tipoOperacion'] = parseInt(results[k]["tipoOperacion"].toString().trim()) == 1 ? "TOCE.IMP" : "TOCE.EXP";
                        facturas[key_factura]['patenteAduanal'] = results[k]["patenteAduanal"].toString().trim();
                        facturas[key_factura]['fechaExpedicion'] = results[k]["fechaExpedicion"].toString();
                        if (results[k]["observaciones"] != null)
                            facturas[key_factura]['observaciones'] = results[k]["observaciones"].toString();
                        if (results[k]["rfcConsulta"] != null)
                            facturas[key_factura]['rfcConsulta'] = results[k]["rfcConsulta"];
                        facturas[key_factura]['tipoFigura'] = results[k]["tipoFigura"].toString();
                        facturas[key_factura]['correoElectronico'] = results[k]["correoElectronico"];
                        facturas[key_factura]['numeroFacturaOriginal'] = key_factura;
                        if (facturas[key_factura]['numeroRelacionFacturas'] == undefined)
                            facturas[key_factura]['numeroRelacionFacturas'] = results[k]["relaciondeFacturas"].toString();
                        facturas[key_factura]['factura'] = {
                            certificadoOrigen: results[k]["certificadoOrigen"].toString(),
                            numeroExportadorAutorizado: results[k]["numeroExportadorAutorizado"] != null ? results[k]["numeroExportadorAutorizado"].toString() : null,
                            subdivision: results[k]["subdivision"].toString(),                            
                        };

                        var emisor = await this.verificaEmisor(results[k]["emisor"], "domicilio");
                        facturas[key_factura]['emisor'] = {
                            tipoIdentificador: emisor.identificador!=null?emisor.identificador.clave.toString():"0",
                            identificacion: emisor.rfc,
                            nombre: emisor.razon_social,
                            domicilio: {
                                calle: emisor.calle!=null?emisor.calle.toString():"",
                                numeroExterior: emisor.numero_exterior!=null?emisor.numero_exterior.toString():"",
                                numeroInterior: emisor.numero_interior!=null?emisor.numero_interior.toString():"",
                                colonia: emisor.colonia!=null?emisor.colonia.toString():"",
                                localidad: emisor.ciudad!=null?emisor.ciudad.toString():"",
                                municipio: emisor.municipio!=null?emisor.municipio.toString():"",
                                entidadFederativa: emisor.estado!=null?emisor.estado.nombre.toString():"",
                                pais: emisor.pais!=null?emisor.pais.clave_m3.toString():"",
                                codigoPostal: emisor.codigo_postal!=null?emisor.codigo_postal.toString():"",
                            }
                        };

                        var dest = await this.verificaEmisor(results[k]["destinatario"], "domicilio");
                        facturas[key_factura]['destinatario'] = {
                            tipoIdentificador: dest.identificador!=null?dest.identificador.clave.toString():"0",
                            identificacion: dest.rfc,
                            nombre: dest.razon_social,
                            domicilio: {
                                calle: dest.calle!=null?dest.calle.toString():"",
                                numeroExterior: dest.numero_exterior!=null?dest.numero_exterior.toString():"",
                                numeroInterior: dest.numero_interior!=null?dest.numero_interior.toString():"",
                                colonia: dest.colonia!=null?dest.colonia.toString():"",
                                localidad: dest.ciudad!=null?dest.ciudad.toString():"",
                                municipio: dest.municipio!=null?dest.municipio.toString():"",
                                entidadFederativa: dest.estado!=null?dest.estado.nombre.toString():"",
                                pais: dest.pais!=null?dest.pais.clave_m3.toString():"",
                                codigoPostal: dest.codigo_postal!=null?dest.codigo_postal.toString():"",
                            }
                        };                                               

                        var desEspecific = {};                                    
                        if (results[k]["marca"] != null)
                            desEspecific["marca"] = results[k]["marca"].toString().substring(0,35);
                        if (results[k]["modelo"] != null)
                            desEspecific["modelo"] = results[k]["modelo"].toString().substring(0,50);
                        if (results[k]["subModelo"] != null)
                            desEspecific["subModelo"] = results[k]["subModelo"].toString().substring(0,50);
                        if (results[k]["numeroSerie"] != null)
                            desEspecific["numeroSerie"] = results[k]["numeroSerie"].toString().substring(0,25);
                        

                        if (facturas[key_factura]["mercancias"][numPartida]["descripcionGenerica"] != null){
                            if (Object.keys(desEspecific).length > 0)                                
                                facturas[key_factura]["mercancias"][numPartida]['descripcionesEspecificas'].push(desEspecific);
                        } else {
                            var descAuxiliar = []
                            if (Object.keys(desEspecific).length > 0)                                
                                descAuxiliar.push(desEspecific)
                            facturas[key_factura]["mercancias"][numPartida] = {
                                descripcionGenerica: results[k]["descripcionGenerica"],
                                claveUnidadMedida: results[k]["claveUnidadMedida"].toString(),
                                tipoMoneda: results[k]["tipoMoneda"].toString(),
                                cantidad: results[k]["cantidad"].toString(),
                                valorUnitario: results[k]["valorUnitario"].toString(),
                                valorTotal: results[k]["valorTotal"].toString(),
                                valorDolares: results[k]["valorDolares"].toString(),
                                descripcionesEspecificas: descAuxiliar,
                            };
                        }
                     
                    } //for results
                    
                    
                    for (var k in facturas) {
                        resultadoFinal.push(facturas[k]);
                    }
                    
                    let datos = {
                        rfc: this.rfc,
                        fecha: moment().format("YYYY-MM-DD HH:mm:ss"),
                        usuario_email: this.$local_storage.get("email"),
                        facturas: resultadoFinal,
                        nombre_proceso: this.nombre_proceso,  
                        file: this.file,                      
                        ext: this.ext_file
                    };

                    //console.log(datos);
                    
                    axios
                        .post(this.URL + "save_cove/", datos)                                                                      
                        .then(() => {                            
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "El layout se cargó correctamente. Puede transmitir los Coves cuando lo requiera.",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            //console.log(err.response);
                            var errores = "";
                            if (err.response.data != undefined) {
                                if (err.response.data.mensaje != undefined) {
                                    if (typeof err.response.data.mensaje == "string")
                                        errores += err.response.data.mensaje;
                                    else
                                        errores += err.response.data.mensaje[0];

                                } else {
                                    Object.keys(err.response.data).forEach(function (key) {
                                        errores += key + ": " + err.response.data[key];
                                        errores += "<br>";
                                    });

                                }
                            }
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo. \nVerifique que los encabezados correspondan con el layout.",
                                footer: errores
                            });
                        })
                        .then(() => {
                            this.cargar();
                            this.$root.$dialogLoader.hide();
                        });
                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        },        

        transmitir: function (row_id) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let datos = {
                id: row_id,
                usuario: this.usuario,
                id_cliente: this.cliente,
                rfc: this.rfc,
                usuario_email: this.$local_storage.get("email")
            };
            axios
                .post(this.URL + "transmitir/", datos)                
                .then(() => {
                    this.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "Se ha iniciado el proceso de transmisión. Recibirá una notificación cuando el resultado esté disponible.",
                        footer: ""
                    });
                })
                .catch(err => {
                    //console.log(err.response);
                    var errores = "";
                    if (err.response.data != undefined) {
                        if (err.response.data.mensaje != undefined) {
                            if (typeof err.response.data.mensaje == "string")
                                errores += err.response.data.mensaje;
                            else
                                errores += err.response.data.mensaje[0];

                        } else {
                            Object.keys(err.response.data).forEach(function (key) {
                                errores += key + ": " + err.response.data[key];
                                errores += "<br>";
                            });

                        }
                    }
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al intentar transmitir los coves.",
                        footer: errores
                    });
                })
                .then(() => {
                    this.cargar();
                    this.$root.$dialogLoader.hide();
                });
        },

        deleteRegistro: function (id) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: id
            };
            axios.post(this.URL + "elimina_cove/", datos)
                .then(res => {

                    this.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "El registro se eliminó correctamente.",
                        footer: ""
                    });

                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al eliminar el registro.",
                        footer: ""
                    });
                    console.log(err);
                }).then(() => {
                    this.cargar();
                    this.$root.$dialogLoader.hide();
                });
        },

        downloadLayout: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "descargas.econnectpro.mx"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        //a.download = name[name.length - 1];
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        downloadFile: function(key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            let nombre_download = key.split("/").pop();
            
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                if (typeof res.data !== 'undefined') {
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = res.data.mensaje;
                    a.target = '_blank';
                    a.click();
                    a.parentNode.removeChild(a);

                } else {
                    this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                    footer: '',
                    });
                }
                })
                .catch((error) => {
                var mensaje = "Ocurrió un error al descargar el archivo";
                if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                    mensaje = error.response.data.mensaje;
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: mensaje,
                    footer: '',
                });
                console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        downloadVistaPrevia: function(idCove, intento=0){            
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..'); 
            var key = this.$local_storage.get("rfc")+"/coves/vista_previa/"+idCove.toString()+".pdf"
            var datoss3 = {
                id: key,
                bucket: "production.econnect.ds"
            }
            let nombre_download = key.split("/").pop();
            
            axios.post(this.$hostname + 's3/download_url/', datoss3)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {                        
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = '_blank';
                        a.click();
                        a.parentNode.removeChild(a);
                        this.$root.$dialogLoader.hide();
                    } else {
                        if (intento == 0){
                            this.generaVistaPrevia(idCove);                           
                        } else if(intento > 4) {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al generar vista previa. Favor de intentar nuevamente.",
                                footer: '',
                            });
                            this.$root.$dialogLoader.hide();
                        } else {
                            this.downloadVistaPrevia(idCove, intento+1);
                        }
                        
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    
                    if (mensaje.indexOf("El archivo no existe en S3")!=-1 && intento<=4){
                        if (intento==0)
                            this.generaVistaPrevia(idCove);                            
                        else
                            this.downloadVistaPrevia(idCove, intento+1);
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: '',
                        });
                        console.log(error);
                        this.$root.$dialogLoader.hide();
                    }                    
                });
            
        },
        generaVistaPrevia: function(idCove){                                          
            var datos = {
                id_documento: idCove,
                id_cliente: this.$local_storage.get("id_cliente"),
            };            
            axios.post(this.$hostname + "vucem/pdf_cove_preview/", datos)                                    
            .then(res => {
                this.downloadVistaPrevia(idCove, 1);
            })
            .catch(error => {
                if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined){
                    var mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    this.$root.$dialogLoader.hide();     
                } else {//Si es un timeout intentamos descargar el archivo
                    this.downloadVistaPrevia(idCove, 1);
                }                    
                console.log(error);
            });            
        },
        cargarDetalleFactura: function (idCove) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');  
            this.idCoveVistaPrevia = idCove;
            var datos = {
                id_cove: idCove
            };
            axios
                .post(this.URL + "get_detalle_factura_coves/", datos)                               
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.detalle_factura = res.data.detalle;
                        this.nombresRfcConsulta = res.data.nombres;                                                 
                        this.modalPdfCove = true;
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el detalle del cove. Favor de comunicarse con soporte.",
                        footer: ""
                    });
                    console.log(err);
                }).then(() => {                    
                    this.$root.$dialogLoader.hide();                    
                });
        },
        generaPDF(idHtml) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');            
            var thisObj=this;   
            this.showImages = false;         

            var opt = {
                margin: [1.2, 0.5, 0.7, 0.70], //top, left, bottom, right
                filename: "COVE_Vista_Previa.pdf",
                image: {
                    type: "jpeg",
                    quality: 0.5
                },
                html2canvas: {
                    scale: 2
                },
                pagebreak: {
                    mode: ["css", "legacy"] //"avoid-all",
                },
                jsPDF: {
                    unit: "in",
                    format: "letter",
                    orientation: "portrait",      
                    compress: true,                                 
                }
            };            

            
            var html = document.getElementById(idHtml);   
            html2pdf()
                .set(opt)                    
                .from(html)        
                .toPdf().get('pdf')
                .then(function(pdf){                    
                    var totalPages = pdf.internal.getNumberOfPages();

                    for (var i = 1; i <= totalPages; i++) {
                        var imagenH = document.getElementById("imageHeader");                        
                        pdf.setPage(i);                        
                        pdf.setFontSize(9);
                        //pdf.internal.pageSize.getWidth()  //Ancho de página
                        //pdf.internal.pageSize.getHeight()  //Alto de página
                        pdf.addImage(imagenH, "PNG", 0.5, 0.4, 2.0, .45);
                        pdf.text("__________________________________________________________________________________________________________", 
                            0.5, .95);
                        pdf.text("__________________________________________________________________________________________________________", 
                            0.5, pdf.internal.pageSize.getHeight() - 0.55);                                                
                        pdf.text(i +" / " + totalPages, 
                            pdf.internal.pageSize.getWidth() - .9, pdf.internal.pageSize.getHeight() - 0.4);
                    }                        
                        thisObj.showImages = true;
                        thisObj.$root.$dialogLoader.hide();                                                                 
                }).save();  
            
            
            
                 

        }, 

    }, //methods

    created: function () {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.URL = this.$hostname + "transmitir_cove/";
        this.cliente = this.$local_storage.get("id_cliente");
        this.usuario = this.$local_storage.get("id_usuario");
        this.rfc = this.$local_storage.get("rfc");
        this.cargarAduanas();
        this.cargarUnidadesMedida();
        this.cargarTiposMoneda();
        this.cargarPaises();
        this.cargarEmisores();
        this.cargarCertificados();
        this.cargar();
       
    }
};
</script>
<style scoped>
.manual > table > tr { page-break-inside: avoid }

.title-table {
    font-weight: bold !important;
    background-color: lightgray !important;
}

.manual > table {
    width: 100%;
    border-collapse: collapse;
}

.manual > table, td {
    padding-left: 2px;
    border: 1px solid #282828;
    height: 20px;
}
.titulo-principal {
    font-size: 1.1rem !important;
    font-weight: bold;
}
.manual {
    margin: 0px;
    padding: 0px;
    /*height: auto;
    width: auto; 
    background-color: #fff;*/
    text-align: justify;
    font-family: Arial;
    font-size: 0.90rem;
}
</style>